/**
 * "?assessment=<id>" (or "other") limits the student's assessment pages to
 * one uploaded assessment of the module. Without it they show every question.
 */

export const assessmentParam = (search) => new URLSearchParams(search || "").get("assessment");

export const inAssessment = (problem, param) => {
  if (!param) return true;
  if (param === "other") return !problem.assessment;
  return String(problem.assessment?.id ?? "") === String(param);
};

export const withAssessment = (path, param) => (param ? `${path}?assessment=${encodeURIComponent(param)}` : path);
